import { counterpartApiConnector } from 'apiConnector/counterpart/counterpart';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { CompactSelector } from 'components/shared/compact-selector';
import { useSalesCounterpartButton } from 'components/shared/compact-selector/use-toggle-button';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { SalesCounterPartResult } from 'components/shared/SalesCounterPart/SalesCounterPartResult';
import { SelectSearch } from 'components/shared/SelectSearch/SelectSearch';
import type { IntlKey } from 'locales';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { httpClient } from 'utils/http/httpClient';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';

export function MultipleApplyClientListField({ node: { id }, workspaceType }: ProductNodeBuilderProps) {
  const [value, setValue] = useData<ISalesCounterpart>(id, null)!;
  const translationKey = useFieldTranslationKey(id);
  const { label, className } = useSalesCounterpartButton(value, true);
  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={`form.${translationKey}` as IntlKey}
      workspaceType={workspaceType}
      contentPosition="bottom"
    >
      <CompactSelector
        renderButton={(ref, onClick) => (
          <CompactSelector.ToggleButton
            e2ePrefix="client"
            ref={ref}
            id="client"
            label={label}
            className={className}
            onClick={onClick}
          />
        )}
        selectedValue={value}
        hasBorder
        onSelectedItemChanged={client => {
          setValue(client || null);
        }}
        renderContent={onSelectedChanged => (
          <SelectSearch
            autofocus
            getSearchResult={query => counterpartApiConnector(httpClient).fetchSalesCounterparts(query)}
            onValueSelected={onSelectedChanged}
            resultRenderer={SalesCounterPartResult}
            deduplicateComparator={(client1, client2) => client1.id === client2.id}
          />
        )}
        renderInlineWhenOpened
      />
    </BlockOrientationFormGroup>
  );
}
